import Cookie from "js-cookie";
import { env } from "@/utils/config";

const domainConfig = {
    production: ".hxylt.org.cn",
    development: ".doclive.cn",
    local: ""
};
const domain = domainConfig[env];
const expires = 3;
const TOKEN_NAME = "common-token";
export function getToken() {
  let token = Cookie.get(TOKEN_NAME, { domain });
  return token ? token : "";
}
export function setToken(token) {
  console.log(token, "token");
  Cookie.set(TOKEN_NAME, token, { domain, expires });
}
export function clearToken() {
  Cookie.remove(TOKEN_NAME, { domain });
}
